module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (4).a4dbbe03.svg";